module.exports = __webpack_public_path__ + "kudos_79.svg?511d1fdc200e170ed8600282c6c1495c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_79.svg
// module id = 182
// module chunks = 0